import styled from 'styled-components';

// 팝업 스타일 props 타입
type PopupStyleProps = {
  x: number;
  y: number;
  position: 'top' | 'bottom';
  arrowOffset: number;
};

// DatePicker 스타일
export const MonthPickerPopupStyle = styled.div`
  position: absolute;
  top: 6%;
  background-color: var(--tonal-light);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  z-index: 1000;

  .month-picker-close {
    position: absolute;
    top: 0.25rem;
    right: 0.5rem;
    display: none;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    min-height: 2.75rem;
    padding: 0;
    border: none;
    border-radius: 50%;
    background-color: transparent;
    color: var(--text-secondary);
    cursor: pointer;

    .material-symbols-rounded {
      font-size: 1.5rem;
    }
  }

  .year-month-selector {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .year-selector {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;

      select {
        padding: 0.25rem;
        border-radius: 4px;
        border: 1px solid var(--tonal);
        outline: none;

        &:focus {
          border-color: var(--primary);
        }
      }
    }

    .month-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 0.5rem;

      button {
        padding: 0.5rem;
        border: 1px solid var(--outline);
        border-radius: 4px;
        background-color: white;
        cursor: pointer;

        &:hover {
          border: 1px solid var(--filled-blue-light);
        }

        &.selected {
          background-color: var(--tonal-blue);
          color: white;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    max-width: 20rem;

    .month-picker-close {
      display: flex;
    }

    .year-month-selector {
      margin-top: 2.25rem;
    }

    .year-month-selector > .month-grid > button {
      height: fit-content !important;
      padding: 10px 5px !important;
      font-size: 1rem !important;
    }
  }
`;

// 팝업 스타일
export const ScheduleShowMorePopupStyle = styled.div<PopupStyleProps>`
  position: fixed;
  top: ${(props) => props.y}px;
  left: ${(props) => props.x}px;
  background-color: var(--tonal-light);
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 4999;
  width: 500px;
  min-height: 300px;
  max-height: 80dvh;
  display: flex;
  flex-direction: column; // 수직 방향 레이아웃

  .popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid var(--outline);
    position: relative;

    @media screen and (max-width: 768px) {
      background-color: var(--tonal-light);
      padding: 0.5rem 2.5rem;
      position: sticky !important;
      top: 0 !important;
      z-index: 10 !important;
      flex-shrink: 0; /* 헤더가 줄어들지 않도록 */
    }

    h3 {
      margin: 0;
      color: var(--text-primary);
      font-size: 1.125rem;

      .popup-date-text {
        @media screen and (max-width: 768px) {
          line-height: 2.6rem;
        }
      }
    }

    .close-button {
      position: absolute;
      right: -5px;
      top: -5px;
      width: 2.5rem;
      height: 2.5rem;
      border: none;
      background: none;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      @media screen and (max-width: 768px) {
        right: 0.8rem;
        top: 0.6rem;
      }

      .material-symbols-rounded {
        font-size: 2rem;
        color: var(--text-secondary);
        transition: color 0.2s ease;
      }

      &:hover .material-symbols-rounded {
        color: var(--text-primary);
        background-color: var(--tonal);
        padding: 2px;
        border-radius: 5px;
      }
    }
  }

  .popup-content {
    height: 200px;
    overflow-y: auto;
    transition: transform 0.18s ease, opacity 0.18s ease;

    @media screen and (max-width: 767px) {
      flex: 1 1 0; /* flex-basis를 0으로 설정하여 남은 공간 채우기 */
      min-height: 0; /* flex 아이템 크기 제한 */
      overflow-y: auto; /* 스크롤 활성화 */
      padding: 0 1rem; /* 좌우 여백 추가 */
      display: flex; /* flex 컨테이너로 만들기 */
      flex-direction: column; /* 수직 배치 */
      overscroll-behavior: contain; /* 스크롤 체이닝 방지 */
      -webkit-overflow-scrolling: touch; /* iOS 부드러운 스크롤 */
    }

    ul {
      margin-top: auto; // 하단에 고정
      list-style: none;
      padding: 0;
      margin: 0;

      @media screen and (max-width: 767px) {
        flex: 1; /* 남은 공간 모두 차지 */
        display: flex;
        flex-direction: column;
        justify-content: flex-start; /* 상단부터 배치 */
        gap: 0.5rem;
      }

      li {
        display: flex;
        align-items: center;
        position: relative;
        padding: 0.25rem;
        cursor: pointer;
        margin-bottom: 4px;
        border-radius: 5px;
        font-size: 0.9rem;
        gap: 0.5rem;

        &.mobile-schedule-item {
          white-space: inherit;
          margin: 0;
          border-radius: 0;

          // 이벤트 전파 방해 막기
          &:before {
            display: none !important;
          }

          .schedule-type-bg {
            width: 6px;
            height: 100%;
            border-radius: 10px;
          }

          .schedule-info-content {
            display: flex;
            flex-direction: column;
            flex: 1;
            gap: 1.5rem;

            .schedule-info-top {
              display: flex;
              flex-direction: column;
              gap: 0.5rem;

              .event-title {
                font-size: 1rem;
                font-weight: 500;
                line-height: 1.4;
                color: var(--text-primary);
              }

              .schedule-info-attenders {
                display: flex;
                align-items: center;
                gap: 0.5rem;

                .attenders-text {
                  font-size: 0.875rem;
                  color: var(--text-tertiary);
                  font-weight: 400;
                }
              }
            }

            .image-list-wrap {
              display: flex;
              flex-wrap: wrap;
              gap: 0.5rem;
            }

            .schedule-info-files {
              display: flex;
              flex-wrap: wrap;
              gap: 0.5rem;
              position: relative;
              z-index: 1;

              figure {
                position: relative;
                z-index: 10;
                cursor: pointer;
              }

              img {
                border-radius: 0.25rem;
                pointer-events: none;
              }
            }
          }
        }

        .event-title {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 400;
        }

        .bullet {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          flex-shrink: 0;
          margin: 0 5px;
        }

        .important-star {
          color: var(--filled-red);
          font-size: 1rem;
          font-variation-settings: 'FILL' 1, 'wght' 600, 'GRAD' 0, 'opsz' 20;
          background: #fff;
          border-radius: 25%;
        }

        &.completed {
          color: var(--text-secondary);
          .event-title {
            text-decoration: line-through;
          }
        }

        &:last-child {
          margin-bottom: 0;
        }

        &:before {
          display: none;
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 5px;
          background: rgba(0, 0, 0, 0.05);
          width: 100%;
          height: 100%;
        }

        &:hover {
          &:before {
            display: block;
          }
        }
      }
    }

    // 모바일에서 글씨크기 키우기
    @media screen and (max-width: 768px) {
      flex: 1; // 남은 공간 모두 차지
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
      ul {
        li {
          font-size: 1rem !important;
        }
      }
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: ${(props) => props.arrowOffset}px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    pointer-events: none;

    ${(props) =>
      props.position === 'top'
        ? `
      border-top: 6px solid var(--tonal-light);
      bottom: -6px;
      transform: translateX(-50%);
    `
        : `
      border-bottom: 6px solid var(--tonal-light);
      top: -6px;
      transform: translateX(-50%);
    `}
  }

  @media screen and (max-width: 767px) {
    position: fixed !important;
    top: auto !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    transform: translateY(100%);
    width: 100% !important;
    height: fit-content !important;
    max-height: 55vh !important; /* 폴백 (구형 Safari 15.3 이하) */
    max-height: 55dvh !important; /* 최신 브라우저 (Safari 15.4+) */
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    transition: transform 0.3s ease;
    margin: 0 !important;
    display: flex;
    flex-direction: column;
    padding: 0 !important;

    &.active {
      transform: translateY(0);
    }

    &::before {
      display: none;
    }

    .popup-content-wrapper {
      display: flex !important;
      flex-direction: row !important; /* 가로 배치 */
      align-items: stretch !important; /* 모든 자식 요소를 늘림 */
      justify-content: space-between !important;
      flex: 1 1 auto !important; /* flex: 1 대신 flex: 1 1 auto (grow shrink basis) */
      min-height: 0 !important; /* flex 아이템이 컨텐츠 크기를 초과하지 않도록 */
      overflow: hidden !important; /* 내부 스크롤 처리 */
      .popup-content {
        padding: 0;
        height: calc(55dvh - 5rem);
      }
    }
    /* 모바일 전용 좌우 네비게이션 화살표 */
    .nav-arrow {
      /* 버튼 기본 스타일 완전 리셋 */
      all: unset !important;
      padding: 0.625rem;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      box-sizing: border-box !important;
      width: auto !important;
      cursor: pointer !important;

      flex-shrink: 0 !important;
      flex-grow: 0 !important;
      align-self: stretch !important;
    }
    .nav-arrow.left {
      left: 0;
    }
    .nav-arrow.right {
      right: 0;
    }
    .nav-arrow .material-symbols-rounded {
      font-size: 2.5rem;
      color: var(--selected-primary);
      font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    }

    /* 슬라이드 애니메이션 */
    &.nav-left .popup-content {
      transform: translateX(-12px);
      opacity: 0.9;
    }
    &.nav-right .popup-content {
      transform: translateX(12px);
      opacity: 0.9;
    }
  }
`;

// 캘린더 스타일
export const CalendarStyle = styled.div`
  &.loading {
    pointer-events: none;
    cursor: not-allowed;
  }

  &.myCustomHeight {
    position: relative;
    height: calc(100dvh - 7.5rem);

    @media screen and (max-width: 768px) {
      height: calc(100dvh - 7rem) !important;
    }

    &.dashboardStyle {
      height: 100%;
      // 모바일인 경우 높이
      @media screen and (max-width: 768px) {
        height: calc(100dvh - 4.5rem) !important;
      }
    }
    .rbc-addons-dnd .rbc-calendar {
      height: inherit;
      width: 100%;
      box-sizing: border-box;
    }

    .rbc-row-content {
      /* flex-grow: 1; */
    }

    .rbc-month-row {
      .rbc-row {
        height: 22px;
        > .rbc-row-segment {
          height: inherit;
        }
      }
      /* overflow: overlay !important; */

      /* 월별 뷰에서 row-body 높이 최대화 */
      .rbc-row-content {
        height: 100% !important;
        .rbc-addons-dnd-row-body {
          height: calc(100% - 22px) !important; /* 최대 높이 설정 */
        }
      }
    }

    .rbc-calendar {
      position: relative;
      width: 100%;
      box-sizing: border-box;
      height: 100%;
      display: flex;
      flex-direction: column;

      .rbc-toolbar {
        flex-shrink: 0;
      }

      .rbc-agenda-view {
        flex: 1 1 0;
        min-height: 0;
        overflow: auto;
        display: flex;
        flex-direction: column;

        .rbc-agenda-table {
          flex: 0 0 auto;
        }

        @media screen and (max-width: 768px) {
          flex: 1 1 0;
          min-height: 0;
        }
      }
    }

    @media screen and (max-width: 768px) {
      .rbc-header,
      .rbc-date-cell,
      .rbc-label {
        font-size: 12px;
      }
    }

    .custom-event-line {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 0 3px;
      font-size: 0.875rem;
      height: inherit;
      margin: 1px 0; /* 일정 간 간격 최소화 */
      > span {
        line-height: normal;
        height: fit-content;
        max-height: fit-content;
        margin: 1px 0;
        font-weight: 400;
      }

      @media screen and (max-width: 768px) {
        & {
          font-size: 10px;
          height: 1rem;
          gap: 0;
        }
      }

      > span {
        overflow: hidden;
        width: 100%;
        /* text-overflow: ellipsis; */
        white-space: pre;

        @media screen and (max-width: 768px) {
          & {
            padding-left: 2px;
          }
        }
      }

      .bullet {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        flex-shrink: 0;
      }

      .custom-bullet {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        flex-shrink: 0;

        @media screen and (max-width: 768px) {
          & {
            position: absolute;
            top: 0;
            left: 0;
            width: 3px;
            height: 100%;
            border-radius: 0;
          }
        }
      }

      .event-title {
        flex-grow: 1;
        font-size: 0.75rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--text-primary);
        font-weight: 400;

        &.completed {
          text-decoration: line-through;
          color: var(--text-secondary);
        }
      }

      .important-star {
        color: var(--filled-red);
        font-size: 1rem;
        font-variation-settings: 'FILL' 1, 'wght' 600, 'GRAD' 0, 'opsz' 20;
        background: #fff;
        border-radius: 25%;
      }

      @media screen and (max-width: 768px) {
        & {
          font-size: 11px;
          padding: 1px 0;

          .important-star {
            font-size: 0.7rem;
            margin: 0 2px 0 4px;
          }
        }
      }
    }

    /* 월간일정 스타일 */
    .rbc-month-view {
      border: 1px solid var(--outline);
      border-radius: 15px;

      .rbc-header {
        padding: 0.2rem;
        color: var(--text-primary);
        border-bottom: 1px solid var(--outline);
      }

      .rbc-header + .rbc-header {
        border-left: 1px solid var(--outline);
      }

      @media screen and (max-width: 768px) {
        .rbc-row:not(.rbc-month-header) {
          margin-bottom: 1px;
          height: 1.1rem;
          font-size: 11px;
          .rbc-row-segment {
            height: inherit;
            display: flex;
            align-items: center;
            > div {
              height: inherit;
              flex-grow: 1;
              > div {
                height: inherit;
                > div {
                  display: flex;
                  align-items: center;
                  /* height: inherit; */
                }
              }
            }
          }
        }
      }

      .rbc-row-segment {
        // 월간이 아닐때에만 padding 추가
        &:not(.rbc-month-view) {
          padding: 1px;
        }

        .rbc-show-more {
          color: var(--filled-blue-deep);
          font-size: 0.875rem;
          padding: 2px;
          background-color: transparent;
          cursor: pointer;
          width: 100%;
          text-align: start;

          &:hover {
            background-color: var(--tonal-blue);
            border-radius: 4px;
          }

          @media screen and (max-width: 768px) {
            & {
              line-height: 1;
              font-size: 0.875rem;
              padding: 2px;
              text-align: end;

              &:hover {
                background-color: transparent;
              }
            }
          }
        }
      }

      .rbc-month-row + .rbc-month-row {
        border-top: 1px solid var(--outline);
      }

      .rbc-row:not(.rbc-month-header),
      .rbc-day-bg {
        cursor: pointer;
      }

      .rbc-day-bg + .rbc-day-bg {
        border-left: 1px solid var(--outline);
      }

      .rbc-date-cell {
        padding: 2px 5px;
        color: var(--text-primary);
        cursor: pointer;
        > div {
          line-height: normal;
        }

        @media screen and (max-width: 768px) {
          > div {
            line-height: 1;
          }
        }
      }

      .rbc-event {
        position: relative;
        overflow: hidden;
        width: calc(100% - 2px) !important;
        margin: 0 1px;
        pointer-events: auto;

        &.event-fixed {
          cursor: default;
        }
      }

      .rbc-event:not(.event-fixed) {
        .rbc-event-content {
          transition: box-shadow 0.2s ease-in-out, background-color 0.1s ease-in-out;
          box-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0.05);
        }

        &:hover .rbc-event-content {
          box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1);
          background-color: rgba(0, 0, 0, 0.05);
        }
      }
    }

    /* 주간 및 일별 일정 스타일 */
    .rbc-time-view {
      border: 1px solid var(--outline);

      .rbc-time-header.rbc-overflowing {
        border-right: 1px solid var(--outline);
      }

      .rbc-time-header-content {
        border: none;

        .rbc-day-bg + .rbc-day-bg {
          border-left: 1px solid var(--outline);
        }
      }

      .rbc-header {
        border-bottom: 1px solid var(--outline);
        color: var(--text-primary);

        & + .rbc-header {
          border-left: 1px solid var(--outline);
        }
      }

      .rbc-time-content {
        border-top: 2px solid var(--outline);

        .rbc-timeslot-group {
          border-bottom: 1px solid var(--outline);
        }

        & > * + * > * {
          border-left: 1px solid var(--outline);
        }

        .rbc-day-slot {
          .rbc-time-slot {
            border-top: 1px solid var(--outline);
          }
        }

        .rbc-time-slot {
          .rbc-label {
            color: var(--text-primary);
          }
        }
      }

      .rbc-time-header {
        @media screen and (max-width: 1024px) {
          & {
            width: 100%;
            border-right: none !important;
          }
        }

        .rbc-event {
          position: relative;
          overflow: hidden;
        }
      }

      .rbc-event {
        box-shadow: -1px 1px 5px var(--calendar-shadow);

        .rbc-event-content {
          transition: box-shadow 0.2s ease-in-out, background-color 0.1s ease-in-out;
          box-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0.05);
        }

        &:hover .rbc-event-content {
          box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1);
          background-color: rgba(0, 0, 0, 0.05);
        }
      }
    }

    /* agenda 뷰 스타일 */
    .rbc-agenda-view {
      .rbc-agenda-empty {
        text-align: center;
        padding: 2rem;
        color: var(--text-secondary);
        font-size: 0.875rem;
      }

      .rbc-agenda-table {
        border-collapse: collapse;
        width: 100%;
        table-layout: fixed;
        border: none;

        thead {
          border: none;
          th {
            padding: 0.5rem;
            color: var(--text-primary);
            font-weight: 600;
            text-align: center;
            border: none;

            &:first-child {
              &::before {
                content: '날짜';
                color: var(--text-tertiary);
              }
              font-size: 0;
            }

            &:nth-child(2) {
              &::before {
                content: '시간';
                color: var(--text-tertiary);
              }
              font-size: 0;
            }

            &:nth-child(3) {
              &::before {
                content: '일정';
                color: var(--text-tertiary);
              }
              font-size: 0;
            }

            &::before {
              font-size: 0.875rem;
            }

            &:last-child {
              border-right: none;
            }
          }
        }

        tbody {
          td {
            padding: 0.325rem;
            color: var(--text-primary);
            border-right: none;
            vertical-align: middle;
            border-bottom: 1px solid var(--outline);

            &:last-child {
              border-right: none;
            }
          }

          .rbc-agenda-date-cell.agenda-date-today {
            background-color: var(--tonal-green);
          }

          .rbc-agenda-date-cell {
            width: 8%;
            text-align: center;
            min-width: fit-content;

            > .rbc-agenda-date-cell {
              width: 100%;
              text-align: center;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              color: var(--text-secondary);
            }

            // 모바일에서 날짜 셀 내부 미참석자 정보 스타일
            .mobile-absentees-info {
              width: 100%;
              text-align: left;
              margin-top: 0.5rem;
              padding-top: 0.5rem;
              border-top: 1px solid var(--outline);
              font-size: 0.75rem;
              color: var(--text-secondary);
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 0.5rem;
            }
          }

          .rbc-agenda-date-cell-additional {
            width: 10% !important;
            text-align: left;
            padding: 0.5rem;
            vertical-align: center;
            border-left: 1px solid var(--outline);
            > div {
              color: var(--text-tertiary) !important;
              white-space: normal;
              word-break: keep-all;
              font-size: 0.875rem;

              // 미참석자 라벨 스타일
              > div:first-child {
                .material-symbols-rounded {
                  transition: color 0.2s ease;

                  &:hover {
                    color: var(--text-primary) !important;
                  }
                }
              }
            }

            // 모바일에서 숨김
            @media screen and (max-width: 767px) {
              display: none !important;
            }
          }

          .rbc-agenda-time-cell {
            width: 6%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 0.875rem;
            border-left: none !important;
            color: var(--text-secondary);
            .rbc-agenda-time-cell {
              width: 100%;
              text-align: center;
              justify-content: center;
              display: flex;
            }
          }

          .rbc-agenda-event-cell {
            width: 76%;
            color: var(--text-secondary);
            border-left: none !important;
            &:hover {
              background-color: var(--tonal-blue);
              border-radius: 4px;
              cursor: pointer;
            }

            .custom-agenda-event-wrapper {
              display: flex;
              flex-direction: column;
              gap: 0.25rem;

              .custom-event-line {
                display: flex;
                align-items: center;
                gap: 0.5rem;

                .copy-icon-btn {
                  flex: 0 0 auto;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 1.25rem;
                  height: 1.25rem;
                  padding: 0;
                  border: none;
                  background: transparent;
                  cursor: pointer;
                  color: var(--text-secondary);
                  transition: color 0.2s ease, background-color 0.2s ease;
                  border-radius: 4px;

                  .material-symbols-rounded {
                    font-size: 1rem;
                    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20;
                  }

                  &:hover {
                    color: var(--text-primary);
                    background-color: var(--tonal);
                  }

                  &:active {
                    transform: scale(0.95);
                  }
                }

                .agenda-gubun {
                  flex: 0 0 8%;
                  text-align: center;
                  min-width: 0;
                  padding: 0.125rem;
                  border-radius: 4px;
                  font-size: 0.75rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .agenda-company-site-wrapper {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  gap: 0.5rem;
                  flex: 0 0 25%;
                  min-width: 0;
                  overflow: hidden;

                  .agenda-company {
                    flex: 0 0 40%;
                    text-align: start;
                    min-width: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .agenda-site {
                    flex: 0 0 60%;
                    text-align: start;
                    min-width: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
                .agenda-title {
                  flex: 1 1 auto;
                  text-align: start;
                  min-width: 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .agenda-attenders {
                  flex: 0 0 20%;
                  gap: 0.5rem;
                  color: var(--text-secondary);
                  min-width: 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }

          .rbc-continues-prior,
          .rbc-continues-after {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }

      /* agenda view 모바일 반응형 스타일 */
      @media screen and (max-width: 767px) {
        .rbc-agenda-table {
          display: block;
          border: none;

          thead {
            display: none;
          }

          tbody {
            display: block;

            tr {
              display: block;
              width: 100%;
              margin-bottom: 0.5rem;

              /* 모든 td를 블록으로 표시 */
              td {
                display: block;
                width: 100% !important;
                border: none !important;
              }

              /* 날짜 셀이 있는 행 스타일 */
              td.rbc-agenda-date-cell {
                background-color: var(--tonal);
                border-radius: 0.5rem;
                margin-bottom: 0.75rem;
                // border-bottom: 2px solid var(--outline) !important;

                .rbc-agenda-date-cell {
                  width: 100%;
                  font-size: 1rem;
                  font-weight: 600;
                  color: var(--text-primary);
                  text-align: left;
                  display: flex;
                  justify-content: flex-start;
                  padding: 0;
                }
              }

              /* 시간 셀 숨기기 */
              td.rbc-agenda-time-cell {
                display: none !important;
              }

              /* 이벤트 셀 스타일 */
              td.rbc-agenda-event-cell {
                border: 1px solid var(--outline);
                border-radius: 0.5rem;
                margin-left: 0;
                margin-right: 0;
                margin-top: 0;
                margin-bottom: 0.75rem;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
                cursor: pointer;

                .custom-agenda-event-wrapper {
                  width: 100%;
                  pointer-events: auto !important;
                  cursor: pointer;

                  .custom-event-line {
                    display: flex !important;
                    flex-direction: column !important;
                    align-items: flex-start !important;
                    gap: 0.25rem !important;
                    width: 100% !important;
                    height: auto !important;
                    margin: 0 !important;
                    padding: 0 !important;

                    .copy-icon-btn {
                      display: none;
                      /* align-self: flex-end;
                      margin: 0 !important;
                      flex-shrink: 0; */
                    }

                    .agenda-gubun {
                      flex: 0 0 auto;
                      font-size: 0.75rem;
                      padding: 0.25rem 0.5rem;
                      white-space: nowrap;
                      width: fit-content;
                      line-height: 1.5;
                      margin: 0 !important;
                    }

                    .agenda-company-site-wrapper {
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      gap: 0.5rem;
                      width: 100%;
                      flex: 0 0 auto;
                      margin: 0 !important;

                      .agenda-company {
                        flex: 0 0 auto;
                        font-size: 0.875rem;
                        white-space: normal;
                        color: var(--text-secondary);
                        line-height: 1.5;
                        margin: 0 !important;
                      }

                      .agenda-site {
                        flex: 0 0 auto;
                        font-size: 0.875rem;
                        white-space: normal;
                        color: var(--text-secondary);
                        line-height: 1.5;
                        margin: 0 !important;
                      }
                    }

                    .agenda-title {
                      flex: 0 0 auto;
                      font-size: 1rem;
                      font-weight: 500;
                      color: var(--text-primary);
                      white-space: normal;
                      word-break: break-word;
                      width: 100%;
                      line-height: 1.5;
                      margin: 0 !important;
                      min-height: 1.5em;
                    }

                    .agenda-attenders {
                      flex: 0 0 auto;
                      font-size: 0.75rem;
                      color: var(--text-tertiary);
                      white-space: normal;
                      width: 100%;
                      line-height: 1.5;
                      margin: 0 !important;
                      min-height: 1.5em;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .rbc-overlay {
      position: absolute;
      z-index: 1000;
      background-color: white;
      border: 1px solid var(--tonal);
      border-radius: 8px;
      padding: 10px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);

      .rbc-overlay-header {
        padding: 8px;
        color: var(--text-primary);
        font-weight: 500;
        border-bottom: 1px solid var(--tonal);
        margin-bottom: 8px;
      }
    }

    .rbc-event {
      background-color: transparent;
      border: none;
      margin: 0;
      padding: 0;
      pointer-events: auto; /* 클릭 가능 */
      cursor: grab; /* 드래그 가능한 상태 표시 */
    }

    .rbc-event-label {
      display: none;
    }

    .rbc-event:active {
      cursor: grabbing; /* 드래그 중 상태 표시 */
    }

    /* 월간 뷰에서만 커스텀 드래그 프리뷰 스타일 적용 */
    .rbc-month-view .rbc-addons-dnd-drag-preview {
      position: fixed !important;
      pointer-events: none !important;
      z-index: 99999 !important; /* 메뉴(z-index: 5001)보다 높게 설정 */
      opacity: 0.9 !important;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
      padding: 4px 8px !important;
      border-radius: 4px !important;
      white-space: nowrap !important;
      overflow: hidden !important;
      box-sizing: border-box !important;
      flex: none !important;
      flex-grow: 0 !important;
      flex-shrink: 0 !important;

      .custom-event-line {
        display: flex !important;
        align-items: center !important;
        gap: 4px !important;
        width: 100% !important;
        flex: none !important;

        span {
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
        }
      }
    }

    .rbc-addons-dnd-dragging {
      opacity: 0.5;
    }

    /* 드래그 중 마우스 아래 날짜 셀 음영 효과 */
    .rbc-day-bg.drag-over-highlight {
      background-color: rgba(59, 130, 246, 0.2) !important;
      transition: background-color 0.15s ease !important;
    }

    .rbc-month-view .rbc-day-bg.drag-over-highlight {
      background-color: rgba(59, 130, 246, 0.2) !important;
    }

    .rbc-time-view .rbc-day-slot.drag-over-highlight {
      background-color: rgba(59, 130, 246, 0.2) !important;
    }

    .rbc-day-slot.drag-over-highlight {
      background-color: rgba(59, 130, 246, 0.2) !important;
    }

    .rbc-events-container {
      margin-right: 0;
      cursor: pointer;
    }

    .rbc-event.rbc-selected {
      background-color: transparent;
    }

    .rbc-event:focus {
      outline: none;
    }

    .rbc-off-range-bg {
      background-color: var(--tonal-light);
    }

    .rbc-today {
      background-color: var(--tonal-green);
      border: 1px solid var(--filled-green-light) !important;
      border-left: 1px solid var(--filled-green-light) !important;
    }

    .rbc-time-header-gutter {
      width: 79.3906px; /* 주간일정 상단 시간셀 고정너비 */
      min-width: 79.3906px;
      max-width: 79.3906px;
    }

    /* 2주/3주 뷰에서 타임라인과 시간별 일정 영역 숨기기 */
    .rbc-multi-week-view > div {
      // 각 주 컨테이너가 전체 높이를 차지하도록
      height: 100% !important;
      position: relative !important; // 상대 위치 설정
    }

    .rbc-multi-week-view .rbc-time-view {
      border: none !important;
      height: auto !important; // 자동 높이로 변경
      min-height: 100% !important; // 최소 높이는 100%
      display: flex !important;
      flex-direction: column !important;
      flex: 1 1 auto !important; // flex로 남은 공간 모두 차지
      width: 100% !important;
      box-sizing: border-box !important;

      // 타임라인 gutter 전체 숨기기
      .rbc-time-header-gutter,
      .rbc-time-gutter {
        display: none !important;
        visibility: hidden !important;
        width: 0 !important;
        min-width: 0 !important;
        max-width: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        overflow: hidden !important;
      }

      // 종일 일정 영역이 전체 높이를 차지하도록
      .rbc-time-header {
        flex: 1 1 auto !important;
        min-height: 100% !important; // 최소 높이를 100%로 설정
        height: 100% !important; // 높이를 100%로 설정
        display: flex !important;
        flex-direction: column !important;
      }

      .rbc-time-header-content {
        flex: 1 1 auto !important;
        min-height: 100% !important; // 최소 높이를 100%로 설정
        height: 100% !important; // 높이를 100%로 설정
        display: flex !important;
        flex-direction: column !important;
      }

      .rbc-allday-cell {
        flex: 1 1 auto !important;
        min-height: 100% !important; // 최소 높이를 100%로 설정
        height: 100% !important; // 높이를 100%로 설정
      }

      // 시간별 일정 영역 전체 숨기기 (allDay 일정만 보이도록)
      .rbc-time-content {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        min-height: 0 !important;
        max-height: 0 !important;
        overflow: hidden !important;
        flex: 0 0 0 !important;
      }

      // 시간 슬롯의 라벨도 숨기기
      .rbc-time-slot .rbc-label {
        display: none !important;
        visibility: hidden !important;
      }

      // 타임라인 관련 모든 요소 숨기기
      .rbc-time-header-content .rbc-time-header-gutter,
      .rbc-time-content .rbc-time-gutter,
      .rbc-time-header .rbc-time-header-gutter {
        border: none !important;
        display: none !important;
        visibility: hidden !important;
        width: 0 !important;
        min-width: 0 !important;
        max-width: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        overflow: hidden !important;
      }

      // 타임라인 컬럼 전체 숨기기
      > .rbc-time-header > .rbc-time-header-gutter,
      > .rbc-time-content > .rbc-time-gutter {
        display: none !important;
        visibility: hidden !important;
        width: 0 !important;
        min-width: 0 !important;
        max-width: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        overflow: hidden !important;
      }
    }

    .rbc-time-slot {
      text-align: start;
    }

    .rbc-time-header {
      // width: calc(100% - 11px); /* 스크롤바를 고려한 고정 폭 */
    }

    .rbc-current-time-indicator {
      display: none;
    }

    .rbc-label {
      user-select: none;
    }
  }

  .month-title-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
  }

  .dashboardStyle {
    justify-content: center;
    width: 100%;

    &.mobile {
      align-items: stretch;
    }

    > div > div > div > button > span {
      font-size: 2.5rem;
    }

    .month-title {
      font-size: 1.5rem !important;
    }

    .toolbar {
      padding-bottom: 0;
      width: 100%;
    }

    .btn-wrapper {
      width: 100%;
      align-items: center;
    }

    .my-events-btn {
      padding: 0 0.5rem !important;
      margin: 0 0.5rem !important;
      width: fit-content !important;
      height: 2rem !important;
      background-color: var(--tonal) !important;
      color: var(--text-tertiary) !important;
      font-size: 0.875rem !important;

      display: flex;
      justify-content: flex-end;
      align-items: center;

      position: relative;
      right: 0;
      transform: translateX(0);

      &.active {
        background-color: var(--selected-primary) !important;
        color: #ffffff !important;
        font-weight: bold;
      }

      &:hover {
        font-weight: bold;
      }
    }
  }
`;

// 툴바 스타일
export const ToolbarStyle = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 0.5rem;

  &.mobile {
    padding: 0;
    flex-direction: column;

    .toolbar {
      .month-title {
        font-size: 1.25rem;

        @media screen and (max-width: 768px) {
          & {
            font-size: 1rem;
          }
        }
      }

      .btns {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        button {
          height: 0;
          padding: 0;
        }
      }

      .btns-wrapper {
        display: flex;
        align-items: center;
        gap: 0.375rem;

        > button {
          padding: 0.375rem;
          width: fit-content;
          height: fit-content;
          min-width: 2rem;
          min-height: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid var(--outline);
          border-radius: 0.25rem;
          background-color: var(--primary);
          transition: background-color 0.2s ease;

          > span {
            font-size: 1.25rem;
            color: var(--tonal);
            font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
          }

          &:hover {
            background-color: var(--filled-blue-light);
          }
        }

        > .my-events-btn {
          background-color: var(--tonal-light) !important;
          border: 1px solid var(--outline);
          border-radius: 0.25rem;

          > span {
            color: var(--text-secondary);
          }

          &.active {
            background-color: var(--selected-primary) !important;
            border-color: var(--selected-primary);

            > span {
              color: #ffffff;
            }
          }

          &:hover {
            background-color: var(--tonal);
          }

          &.active:hover {
            background-color: var(--filled-blue-deep);
          }
        }

        > .refresh-btn {
          border: 1px solid var(--outline);
          border-radius: 0.25rem;
          padding: 0.375rem;
          width: fit-content;
          height: fit-content;
          min-width: 2rem;
          min-height: 2rem;
          background-color: var(--tonal-light);
          display: flex;
          align-items: center;
          justify-content: center;

          > span {
            color: var(--text-secondary);
          }

          &:hover {
            background-color: var(--tonal);
          }
        }

        // 뷰 선택 드롭다운도 동일한 크기로
        > div {
          > div {
            height: 2rem !important;

            ul {
              height: 2rem !important;

              li.defaultOption {
                height: 2rem !important;
                line-height: 2rem !important;
                padding-left: 0.5rem !important;
                min-width: 3.5rem !important;

                > span {
                  font-size: 0.875rem !important;
                  line-height: 2rem !important;
                }

                > div {
                  width: 1.5rem !important;
                  height: 2rem !important;

                  > span {
                    font-size: 1rem !important;
                  }
                }
              }
            }
          }
        }
      }
    }

    .center {
      justify-content: space-between;
    }

    .right {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
    }

    .toolbar {
      .btn-wrapper {
        button {
          padding: 0;
          font-size: 13px;
        }
      }

      .gubun-guide-wrap {
        padding: 0;
        gap: 0.125rem;

        .gubun-guide-item {
          b {
            font-size: 13px;

            @media screen and (max-width: 768px) {
              & {
                font-size: 11px;
              }
            }
          }
        }
      }
    }

    .btn-bottom-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      .toolbar.right {
        justify-content: space-between;
        width: 100%;

        @media screen and (max-width: 768px) {
          & {
            display: none;
            justify-content: flex-end;
          }
        }
      }
    }

    .btn-wrapper {
      display: flex;
      gap: 0.25rem;

      &.today-btn {
        margin-left: 1rem;

        @media screen and (max-width: 768px) {
          margin-left: 0.25rem !important;
          & {
            margin: 0.5rem 0;
            > button {
              height: 0% !important;
              padding: 0 0.5rem !important;
              width: auto !important;
            }
          }
        }
        button {
          height: auto;
          padding: 4px 8px;
          background-color: var(--primary);
          font-size: 0.85rem;

          &.active {
            background-color: var(--filled-blue-deep);
            font-weight: bold;
          }

          &:hover {
            background-color: var(--filled-blue-light);
          }
        }
      }
    }
  }

  .toolbar {
    display: flex;

    @media screen and (max-width: 768px) {
      & {
        padding-bottom: 0.3rem !important;
      }
    }

    &.center {
      button {
        background-color: transparent;
        color: var(--text-secondary) !important;
        &.arrow :hover {
          transform: scale(1.2);
          color: var(--primary);
        }
      }

      .left {
        button {
          background-color: var(--primary);
          .add {
            font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
            color: var(--tonal);
          }
        }
      }
    }

    &.left {
      align-items: center;

      // 주간 드롭다운 스타일을 다른 버튼과 동일하게
      .btn-wrapper {
        > div {
          /* width: 4.5rem; */
          // SelectBoxSmDropStyle 래퍼
          > div {
            height: 2rem !important;

            .material-symbols-rounded {
              font-size: 0.875rem;
            }

            ul {
              height: 2rem !important;

              li.defaultOption {
                height: 2rem !important;
                line-height: 2rem !important;
                padding-left: 0.5rem !important;
                background-color: var(--tonal) !important;
                color: var(--text-tertiary) !important;
                min-width: 4.5rem !important;
                width: auto !important;

                > span {
                  line-height: 2rem !important;
                  font-size: 0.875rem !important;
                  color: var(--text-tertiary) !important;
                  font-weight: normal !important;
                  white-space: nowrap !important;
                  overflow: visible !important;
                  text-overflow: clip !important;
                }

                > div {
                  > span {
                    color: var(--text-secondary) !important;
                  }
                }

                // active 상태일 때 (주간/2주/3주 뷰일 때)
                &.active {
                  background-color: var(--filled-blue-deep) !important;

                  > span {
                    color: #fff !important;
                    font-weight: bold !important;
                  }

                  > div > span {
                    color: #fff !important;
                  }
                }

                // opened 상태일 때 (드롭다운이 열렸을 때)
                &.opened {
                  background-color: var(--tonal-deep) !important;

                  > span,
                  > div > span {
                    color: var(--text-primary) !important;
                  }
                }
              }

              .optionBox {
                top: 2.15rem !important;
              }
            }
          }
        }
      }

      .btn-wrapper button {
        height: 2rem;
        padding: 0.5rem 0;
        background-color: var(--tonal);
        font-size: 0.875rem;
        width: 4.2rem;
        color: var(--text-tertiary);

        &.active {
          background-color: var(--filled-blue-deep);
          color: #fff;
          font-weight: bold;
        }

        &:not(.active):hover {
          background-color: var(--inverse-alpha-25);
        }
      }
    }

    &.right {
      align-items: center;
    }

    .btn-wrapper {
      display: flex;
      gap: 0.25rem;

      &.write-btn {
        margin-left: 1rem;

        button {
          width: 4.5rem;
          height: 2.5rem;
          padding: 0.75rem 0;
          background-color: var(--primary);
          font-size: 0.85rem;

          &.active {
            background-color: var(--filled-blue-deep);
            font-weight: bold;
          }

          &:hover {
            background-color: var(--filled-blue-light);
          }
        }
      }
    }

    .month-title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.5rem;
      padding: 0 0.5rem;
      color: var(--text-primary);
      cursor: pointer;
      white-space: nowrap; /* 초기 레이아웃에서 타이틀이 세로로 줄바꿈되어 툴바가 커지는 것 방지 */
    }

    .gubun-guide-wrap {
      display: flex;
      align-items: center;
      padding: 0.5rem;
      border-radius: 0.5rem;
      gap: 0.875rem;

      .gubun-guide-item {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        color: var(--text-primary);
        font-size: 0.875rem;
        cursor: pointer;

        @media screen and (max-width: 768px) {
          & {
            font-size: 11px;
          }
        }

        label {
          cursor: pointer;
          color: var(--text-primary);
        }

        > span {
          display: block;
          border-radius: 50%;
          width: 0.75rem;
          height: 0.75rem;
        }

        b {
          font-size: 0.875rem;
        }
      }
    }

    /* .rbc-event {
      pointer-events: auto; 
      z-index: 1000; 
    } */
  }
`;

// 오버레이 스타일 컴포넌트
export const OverlayStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 768px) {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.3s ease;
    &.active {
      opacity: 1;
    }
  }
`;

// 일정추가 팝업 스타일
export const ScheduleAddPopupStyle = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  min-width: 500px;
  min-height: 400px;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  z-index: 1000;

  .popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid var(--outline);

    h3 {
      margin: 0;
      font-size: 1.125rem;
      font-weight: 500;
      color: var(--text-primary);
    }

    .close-button {
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      color: var(--text-secondary);

      &:hover {
        color: var(--text-primary);
      }

      span {
        font-size: 20px;
      }
    }
  }

  .popup-content {
    padding: 20px;
    max-height: calc(80vh - 60px); // 뷰포트 높이의 80%에서 헤더 높이를 뺀 값
  }
`;
